var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDateTransactedi = function SvgDateTransactedi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#454B56",
    fillRule: "evenodd",
    d: "M3.67 10.123v9.876c0 .166.136.3.301.3h6.107a.7.7 0 1 1 0 1.4H3.97c-.939 0-1.701-.76-1.701-1.7V5.69c0-.938.762-1.7 1.701-1.7H6.37V3a.701.701 0 0 1 1.402 0v.99h3.469V3a.701.701 0 0 1 1.402 0v.99h3.585V3a.701.701 0 0 1 1.402 0v.99h2.398c.94 0 1.702.762 1.702 1.7v4.774a.7.7 0 0 1-1.4 0v-.34zm2.7-4.734H3.97c-.165 0-.3.135-.3.3v3.034h16.658V5.689a.3.3 0 0 0-.3-.3H17.63v.988a.7.7 0 0 1-1.402 0V5.39h-3.585v.988a.7.7 0 0 1-1.402 0V5.39H7.77v.988a.7.7 0 0 1-1.401 0zm8.602 8.931c2.043 0 3.7 1.655 3.7 3.695a3.7 3.7 0 0 1-7.4 0 3.7 3.7 0 0 1 3.7-3.695m0 1.4a2.297 2.297 0 0 0-2.298 2.295 2.297 2.297 0 0 0 2.298 2.294 2.297 2.297 0 0 0 2.298-2.294 2.297 2.297 0 0 0-2.298-2.295m1.412-2.36a.702.702 0 0 1-.968-1.011 3.7 3.7 0 0 1 6.255 2.671c0 .906-.327 1.736-.87 2.379a.7.7 0 1 1-1.072-.902c.337-.399.54-.915.54-1.477a2.298 2.298 0 0 0-3.885-1.66",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDateTransactedi);
export default ForwardRef;